import { render, staticRenderFns } from "./listOrganization.vue?vue&type=template&id=56aea147&"
import script from "./listOrganization.vue?vue&type=script&lang=js&"
export * from "./listOrganization.vue?vue&type=script&lang=js&"
import style0 from "./listOrganization.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports